<div class="mail-sender-modal modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <span class="bootstrap-dialog-title">Send Email</span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="mailForm">
      <div class="row">
        <!-- From -->
        <div class="col-12">
          <div class="form-group required">
            <div class="services-form">
              <input type="email" placeholder="From Email" formControlName="from" />
              <label>From</label>
            </div>
            <div
              *ngIf="mailForm.get('from')?.touched && mailForm.get('from')?.hasError('required')"
              class="error-messages"
            >
              From email is required.
            </div>
            <div *ngIf="mailForm.get('from')?.hasError('email')" class="error-messages">
              Invalid email format.
            </div>
          </div>
        </div>

        <!-- To -->
        <div class="col-12">
          <div class="form-group required">
            <div class="services-form">
              <input type="email" placeholder="To Email" formControlName="to" />
              <label>To</label>
            </div>
            <div
              *ngIf="mailForm.get('to')?.touched && mailForm.get('to')?.hasError('required')"
              class="error-messages"
            >
              To email is required.
            </div>
            <div *ngIf="mailForm.get('to')?.hasError('email')" class="error-messages">
              Invalid email format.
            </div>
          </div>
        </div>

        <!-- Subject -->
        <div class="col-12">
          <div class="form-group required">
            <div class="services-form">
              <input type="text" placeholder="Subject" formControlName="subject" />
              <label>Subject</label>
            </div>
            <div
              *ngIf="
                mailForm.get('subject')?.touched && mailForm.get('subject')?.hasError('required')
              "
              class="error-messages"
            >
              Subject is required.
            </div>
          </div>
        </div>

        <!-- Body -->
        <div class="col-12">
          <div class="form-group required">
            <ckeditor [(ngModel)]="body" formControlName="body" [config]="ckEditorConfig">
            </ckeditor>
            <div
              *ngIf="mailForm.get('body')?.touched && mailForm.get('body')?.hasError('required')"
              class="error-messages"
            >
              Body is required.
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="!mailForm.valid"
      (click)="onSend()"
    >
      Send
    </button>
  </div>
</div>
